<template>
	<div class="trend-item-wrap">
		<div class="item-user">
			<div class="item-user-info">
				<div class="item-user-img">
					<img :src="itemInfo.avatar"/> 
				</div>
				<div class="item-user-text">
					<p class="user-name">
						{{itemInfo.nickname}}
						<img v-if="itemInfo.gender==1" src="../../assets/img/common/ic_user_man@2x.png" alt="" />
						<img v-if="itemInfo.gender==2" src="../../assets/img/common/ic_user_woman@2x.png" alt="" />
					</p>
					<p class="user-related">
						<span v-if="itemInfo.age">{{itemInfo.age}}岁</span>&nbsp;
						<span v-if="itemInfo.height">{{itemInfo.height}}cm</span>&nbsp;
						<span v-if="itemInfo.education">{{itemInfo.education}}</span>&nbsp;
						<span v-if="itemInfo.annual_income">{{itemInfo.annual_income}}</span>&nbsp;
					</p>
				</div>
			</div>
			<div class="item-option">
				<!--<mt-button icon="more" slot="right"></mt-button>-->
			</div>
		</div>
		<div class="item-text">
			<p>{{itemInfo.text}}</p>
		</div>
		<div class="item-imgs" :class="{'one':itemInfo.attach.length==1,'two':itemInfo.attach.length<=4&&itemInfo.attach.length%2==0,'three':itemInfo.attach.length>4||itemInfo.attach.length%3==0}" v-if="itemInfo.type==1&&itemInfo.attach!='0'">
			<div class="img-box" v-for="(item,index) in imgs" :key="index">
				<img :src="item.src" class="preview-img" @click="$preview.open(index,imgs)">   
			</div>
		</div>
		<div class="item-video" v-if="itemInfo.type==2&&itemInfo.video_id!=''">
			<div class="video-img">
				<img :src="itemInfo.attach" alt="" />
				<div class="video-btn" @click="showVideoPlay=1">
					<img src="../../assets/img/trends/dyn_dyn_ic_video.png"/>
				</div>
			</div>
			<video-play v-show="showVideoPlay==1" :vid="itemInfo.video_id" @hideVideoPlay="hideVideoPlay"></video-play>
		</div>
		<div class="item-related">
			<div class="item-tips">
				<span>{{itemInfo.address}}</span>
				<span>{{itemInfo.update_time|toDateTime|relativeTime}}</span>
			</div>
			<div class="item-delete" v-if="itemInfo.uid==uid" @click="deleteItem(itemInfo.d_id)">
				<img src="../../assets/img/trends/dyn_dyn_ic_delete.png"/>删除
			</div>
		</div>
		<!--<div class="item-options">
			<div class="item-money">
				<button v-if="itemInfo.reward_sum==0"><img src="../../assets/img/common/ic_user_man@2x.png"/>打赏</button>
				<img v-if="itemInfo.reward_sum>0" src="../../assets/img/common/ic_user_man@2x.png"/>
				<div class="money-members" v-if="itemInfo.reward_sum>0">
					<img v-for="item in itemInfo.reward" :src="item.avatar" alt="" />
					<span class="money-members-num" v-if="itemInfo.reward_sum>3">+{{itemInfo.reward_sum-3}}</span>
				</div>
			</div>
			<div class="item-other-options">
				<button><img src="../../assets/img/common/ic_user_man@2x.png"/>评论</button>
				<button><img src="../../assets/img/common/ic_user_man@2x.png"/>点赞</button>
			</div>
		</div>-->
		
	</div>
</template>

<script>
	import VideoPlay from "../Common/VideoPlay"
	export default{
		name:"trend-detail-content",
		components:{
			VideoPlay
		},
		props:["uid","itemInfo","itemImgs"],
		data(){
			return{
				showVideoPlay:0,
			}
		},
		computed:{
			imgs(){
				let arr = this.itemImgs;
				let result = arr.map(function(item){
					let img = new Image();
					img.src = item;
					console.log(img.src)
					let obj = {};
					obj.src = img.src;
					img.onload = function(){
						obj.w = img.width;
						obj.h = img.height
					}
					return obj;
				})
				return result
			}
		},
		methods:{
			deleteItem(id){
				console.log(this.uid,id)
				this.$axios({
					url:"Dynamic/DelDynamic",
					method:"post",
					data:{
						uid:this.uid,
						d_id:id
					}
				}).then(res=>{
					console.log(res);
					if(res.data.code==200){
						this.$toast({
							message: res.data.msg,
							position: "bottom",
							duration: 3000
						});
						this.$emit("deleteItem",res.data.code)
					}
				}).catch(err=>{
					console.log(err)
				})
			},
			hideVideoPlay(){
				this.showVideoPlay = 0;
			}
			
		}
	}
</script>

<style scoped>
	.trend-item-wrap{
		margin: 1rem;
		background: #fff;
		padding: 1rem 1rem 0.5rem;
		border-radius: 5px;
		/*box-shadow: 0 5px 7px rgba(84, 21, 249, .1);*/
	}
	.item-user{
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
	.item-user-info{
		display: flex;
		justify-content: flex-start;
		align-items: center;
	}
	.item-user-info .item-user-img img{
		width: 3rem;
		display: block;
		border-radius: 4px;
	}
	.item-user-info .item-user-text{
		flex: 1;
		padding: 0 1rem;
	}
	.item-user-info .item-user-text .user-name{
		display: flex;
		justify-content: flex-start;
		align-items: center;
		font-size: 1rem;
		color: #282828;
	}
	.item-user-info .item-user-text .user-name img{
		width: 1.5rem;
	}
	.item-user-info .item-user-text .user-related{
		font-size: 0.8rem;
		color: #8157f7;
	}
	.item-option .mint-button{
		background: none;
	    border: 0;
	    box-shadow: none;
	    color: #6D34FB;
	}
	.item-text{
		font-size: 0.8rem;
		line-height: 1.2rem;
		color: #282828;
		padding: 0.8rem 0;
	}
	.item-related{
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
	.item-related .item-tips span{
		margin-right: 0.5rem;
		font-size: 0.65rem;
		color: #9e9e9e;
	}
	.item-related .item-delete{
		color: #6D34FB;
		font-size: 0.8rem;
		display: flex;
		justify-content: flex-start;
		align-items: center;
	}
	.item-related .item-delete img{
		width: 1.2rem;
	}
	/*.item-options{
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 0.5rem 0 0;
		border-top: 1px solid #f3f3f3;
		margin-top: 1rem;
	}
	.item-options button,.item-options div{
		display: flex;
		justify-content: flex-start;
		align-items: center;
		outline: 0;
		border: 0;
		background: none;
		padding: 0;
		margin: 0;
		color: #9e9e9e;
	}
	.item-options .item-other-options button{
		margin-left: 0.5rem;
	}
	.item-options button img{
		width: 1.5rem;
		display: block;
	}
	.item-options .item-money img{
		width: 1.5rem;
	}
	.item-options .money-members img{
		width: 1.5rem;
		border: 2px solid #fff;
		border-radius: 50%;
	}
	.item-options .money-members img:nth-of-type(2){
		position: relative;
		left: -0.5rem;
	}
	.item-options .money-members img:nth-of-type(3){
		position: relative;
		left: -1rem;
	}
	.money-members-num{
		width: 1.5rem;
		height: 1.5rem;
		border: 2px solid #fff;
		background: #7644FA;
		border-radius: 50%;
		display: flex;
		justify-content: center;
		align-items: center;
		color: #fff;
		font-size: 0.8rem;
		position: relative;
		left: -1.5rem;
	}*/
	.item-imgs,.item-video{
		margin-bottom: 1rem;
	}
	.item-imgs.one .img-box{
		width: 100%;
		border-radius: 5px;
		overflow: hidden;
		background: #f3f3f3;
	}
	.item-imgs.two{
		display: flex;
		justify-content: space-between;
		align-items: center;
		flex-wrap: wrap;
	}
	.item-imgs.two .img-box{
		width: 40.5vw;
	    border-radius: 5px;
	    margin-bottom: 0.15rem;
	    overflow: hidden;
	    height: 40.5vw;
	    background: #f3f3f3;
	}
	.item-imgs.three{
		display: flex;
		justify-content: flex-start;
		align-items: center;
		flex-wrap: wrap;
	}
	.item-imgs.three .img-box{
		width: 25.6vw;
		border-radius: 5px;
		margin: 0 0.1rem;
		margin-bottom: 0.1rem;
		overflow: hidden;
		height: 25.6vw;
		background: #f3f3f3;
	}
	.item-imgs .img-box{
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.item-imgs .img-box img{
		width: 100%;
		display: block;
	}
	
	.item-video{
		margin-bottom: 1rem;
	}
	.item-video .video-img{
		width: 50%;
		overflow: hidden;
		border-radius: 5px;
		position: relative;
	}
	.item-video .video-img img{
		width: 100%;
		display: block;
	}
	.item-video .video-img .video-btn{
		position: absolute;
		width:100%;
		height: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		top: 0;
		left: 0;
	}
	.item-video .video-img .video-btn img{
		width: 2rem;
	}
</style>


// WEBPACK FOOTER //
// src/components/Trends/TrendDetailContent.vue